/**
 * Management-specific Translations (B2B)
 * =======================================
 * RFQ page, nav items, auth messages
 */

import { Translations } from '../shared/i18n';

export const managementTranslations: Translations = {
    tr: {
        // Nav
        navRfqInvoices: 'RFQ Faturaları',
        navAllInvoices: 'Tüm Faturalar',
        navSettings: 'Ayarlar',

        // RFQ page
        rfqTitle: 'RFQ Faturaları',
        rfqDescription: 'Tamamlanmış RFQ\'larınızdaki faturaları görüntüleyin ve doğrulayın',
        colCompany: 'Şirket',
        colProduct: 'Ürün',
        colSupplierRfq: 'Tedarikçi',
        colCompletionDate: 'Tamamlanma Tarihi',
        colQuantity: 'Miktar',
        colQuotes: 'Teklifler',
        colInvoiceStatus: 'Fatura Durumu',
        noAttachments: 'Ek Yok',
        viewAttachments: 'Ekleri Görüntüle',
        statusUploaded: 'Yüklendi',
        statusMissing: 'Eksik',

        // Auth messages
        authRequired: 'Kimlik Doğrulama Gerekli',
        authMessage: 'Fatura Yönetimi\'ne erişmek için Portal üzerinden giriş yapınız.',
        goToPortal: 'Portal Girişine Git',

        // Invoice list
        allInvoicesTitle: 'Tüm Faturalar',
        allInvoicesDescription: 'OCR ile çıkarılan fatura detaylarını görüntüleyiniz',
    },
    en: {
        // Nav
        navRfqInvoices: 'RFQ Invoices',
        navAllInvoices: 'All Invoices',
        navSettings: 'Settings',

        // RFQ page
        rfqTitle: 'RFQ Invoices',
        rfqDescription: 'View and verify invoices from your completed RFQs',
        colCompany: 'Company',
        colProduct: 'Product',
        colSupplierRfq: 'Supplier',
        colCompletionDate: 'Completion Date',
        colQuantity: 'Quantity',
        colQuotes: 'Quotes',
        colInvoiceStatus: 'Invoice Status',
        noAttachments: 'No Attachments',
        viewAttachments: 'View Attachments',
        statusUploaded: 'Uploaded',
        statusMissing: 'Missing',

        // Auth messages
        authRequired: 'Authentication Required',
        authMessage: 'Please login via the Portal to access Invoice Management.',
        goToPortal: 'Go to Portal Login',

        // Invoice list
        allInvoicesTitle: 'All Invoices',
        allInvoicesDescription: 'View invoice details extracted via OCR',
    },
};
